if (window.gsap && window.ScrollTrigger) {
    window.gsap.registerPlugin(window.ScrollTrigger);

    const animateContentRow = (selector, options) => {
    const elements = gsap.utils.toArray(selector);

    if (!elements.length) {
        return;
    }

    // Groepeer targets per contentrow zodat elke rij pas triggert wanneer hij zelf in beeld komt.
    const groups = new Map();

    elements.forEach((element) => {
        const trigger = element.closest(".contentrow") || element;
        if (!groups.has(trigger)) {
            groups.set(trigger, []);
        }

        groups.get(trigger).push(element);
    });

    groups.forEach((targets, trigger) => {
        gsap.to(targets, {
            scrollTrigger: {
                trigger,
                start: "-=300 center",
            },
            y: 0,
            delay: options?.delay || 0,
            opacity: 1,
            ease: "power1.inOut",
            duration: 0.3,
            stagger: options?.stagger || 0,
        });
    });
    };

animateContentRow(".contentrow_1", { delay: 0 });
animateContentRow(".contentrow_2", { delay: 0 });
animateContentRow(".contentrow_3", { delay: 0 });
animateContentRow(".contentrow_4", { delay: 0 });
animateContentRow(".contentrow_5 .content__image", { delay: 0.15 });
animateContentRow(".contentrow_5 .contentrow__paragraph", { delay: 0.15 });
animateContentRow(".contentrow_6 .contentrow__paragraph", { delay: 0.15 });
animateContentRow(".contentrow_6 .content__image", { delay: 0.15 });
animateContentRow(".contentrow_7", { delay: 0 });
animateContentRow(".contentrow_8", { delay: 0 });
animateContentRow(".contentrow_9 img", { stagger: 0.15, delay: 0 });
animateContentRow(".contentrow_10 img", { stagger: 0.15, delay: 0 });
animateContentRow(".contentrow_10 a", { stagger: 0.15, delay: 0 });
animateContentRow(".contentrow_11", { delay: 0 });
animateContentRow(".contentrow_12", { delay: 0 });
animateContentRow(".contentrow_13", { delay: 0 });
animateContentRow(".contentrow_14", { delay: 0 });
animateContentRow(".contentrow_15", { delay: 0 });
animateContentRow(".contentrow_16", { delay: 0 });
animateContentRow(".contentrow_17", { delay: 0 });
animateContentRow(".contentrow_18", { delay: 0 });
animateContentRow(".contentrow_19", { delay: 0 });
animateContentRow(".contentrow_20", { delay: 0 });
animateContentRow(".contentrow_21", { delay: 0 });
animateContentRow(".contentrow_22", { delay: 0 });
animateContentRow(".contentrow__projects", { delay: 0 });
animateContentRow(".usp__section--contentrow", { delay: 0 });
animateContentRow(".blocks__section", { delay: 0 });

// Functie om de schaal van de afbeelding te vergroten bij mouseover
const scaleImageOnHover = (selector) => {
    const images = document.querySelectorAll(selector);

    if (!images.length) return;

    images.forEach((image) => {
        image.addEventListener('mouseover', () => {
            gsap.to(image, { scale: 1.05, duration: 1 });
        });

        // Terug naar de normale schaal bij mouseout
        image.addEventListener('mouseout', () => {
            gsap.to(image, { scale: 1, duration: 1 });
        });
    });
};

// Roep de functie aan voor de gewenste afbeeldingen
scaleImageOnHover('.contentrow_3 img');
scaleImageOnHover('.contentrow_5 img');
scaleImageOnHover('.contentrow_6 img');
scaleImageOnHover('.contentrow_9 img');
scaleImageOnHover('.contentrow_10 img');
scaleImageOnHover('.contentrow_11 video');

// Helper om Swiper te initialiseren
const initProjectSwiper = () => {
    const swiperEl = document.querySelector('.projectswiper');
    if (!swiperEl) return;

    const projectSwiper = new Swiper('.projectswiper', {
        direction: 'horizontal',
        spaceBetween: 50,
        autoHeight: true,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
        },
        speed: 1000,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        on: {
            init: function () {
                const swiper = this;

                // Zorg dat autoHeight nog een keer wordt ge-update zodra alle images er zijn
                const images = swiper.el.querySelectorAll('img');
                if (images.length) {
                    let loaded = 0;
                    const checkDone = () => {
                        loaded++;
                        if (loaded === images.length) {
                            swiper.updateAutoHeight();
                        }
                    };

                    images.forEach((img) => {
                        if (img.complete) {
                            checkDone();
                        } else {
                            img.addEventListener('load', checkDone, { once: true });
                            img.addEventListener('error', checkDone, { once: true });
                        }
                    });
                } else {
                    swiper.updateAutoHeight();
                }

                // IntersectionObserver voor autoplay (zoals je al had)
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            swiper.autoplay.start();
                        } else {
                            swiper.autoplay.stop();
                        }
                    });
                });

                observer.observe(swiper.el);
            },
            slideChange: function () {
                // Extra zekerheid: bij slide wissel opnieuw hoogte bijwerken
                this.updateAutoHeight();
            },
        },
    });
};

// ScrollTrigger: pas Swiper initialiseren als de rij in beeld komt
    ScrollTrigger.create({
        trigger: ".contentrow_18",
        start: "top center",
        onEnter: () => {
            // Met WP Rocket is window 'load' belangrijker dan alleen DOMContentLoaded
            if (document.readyState === 'complete') {
                initProjectSwiper();
            } else {
                window.addEventListener('load', () => {
                    initProjectSwiper();
                }, { once: true });
            }
        },
        once: true,
    });
}
